var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.boardType != '')?_c('board-list-component',{attrs:{"boardType":`${_vm.boardType}Search`,"searchData":_vm.searchData,"boardName":_vm.boardType}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }